export default __webpack_public_path__ + "static/media/userdefault.c07ebcf2.png";